import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import BEMHelper from '@ynap/bem-helper'
import { ScrollToTopOnMount as ScrollToTop } from '@ynap/scroll-to-top'

import RSVPForm from './RSVPForm'
import FormSkeleton from './FormSkeleton'

const bem = new BEMHelper('Events')

const Events = (props) => {
    const {
        messages,
        user,
        fetchUser,
        createGuestIdentity,
        updateUserSuccess,
        createFastUserSuccess,
        uberToken,
        userSummary,
        automaticMarketingConsent,
        // the purpose of these variables is to make it easier to display parts of the contents with the least amount of changes
        showBanner = false,
        showDetails = false,
        showSuccessMessage = false,
    } = props

    const [isLoading, setIsLoading] = useState(true)

    const dispatch = useDispatch()

    const defaultInitialValues = automaticMarketingConsent ? { maMarketingConsent: 'true' } : undefined

    useEffect(() => {
        if (!uberToken) {
            dispatch(createGuestIdentity)
        }
    }, [])

    useEffect(() => {
        if (userSummary?.registrationStatus === 'RegisteredPerson' && !user) fetchUser()
        if (uberToken && (userSummary === null || user)) {
            setIsLoading(false)
        }
    }, [uberToken, userSummary, user])

    return (
        <section className={bem()}>
            {showBanner ? (
                <header className={bem('banner')}>
                    <div className={bem('brand-logo', 'withBanner')} />
                    <h1 className={bem('title')}>{messages.events.title()}</h1>
                </header>
            ) : (
                <div className={bem('brand-logo')} />
            )}
            <div className={bem('content', showDetails ? 'withDetails' : '')}>
                {updateUserSuccess || createFastUserSuccess ? (
                    <ScrollToTop>
                        <div className={bem('registration-success')}>
                            <h2 className={bem('success-title')}>{messages.events.successTitle()}</h2>
                            {showSuccessMessage && (
                                <p className={bem('success-message')}>{messages.events.successMessage()}</p>
                            )}
                        </div>
                    </ScrollToTop>
                ) : (
                    <div className={bem('registration-form', showDetails ? 'withDetails' : '')}>
                        {showDetails && (
                            <>
                                <p className={bem('description')}>{messages.events.description1()}</p>
                                <p className={bem('description')}>{messages.events.description2()}</p>
                                <ol className={bem('schedule')}>
                                    {Object.keys(messages.events.schedule).map((eventPart) => {
                                        const formattedDate = messages.events.schedule[eventPart].day()
                                        const formattedTime = messages.events.schedule[eventPart].time()
                                        return (
                                            <li key={`event-${formattedDate}-${formattedTime}`}>
                                                <span className={bem('event-date')}>{formattedDate}</span>
                                                <span className={bem('event-time')}>{formattedTime}</span>
                                            </li>
                                        )
                                    })}
                                </ol>
                                <p className={bem('location')}>{messages.events.location()}</p>
                            </>
                        )}
                        {isLoading ? (
                            <FormSkeleton />
                        ) : (
                            <RSVPForm
                                className={bem('form', showDetails ? 'withDetails' : '')}
                                initialValues={user ? user : defaultInitialValues}
                                {...props}
                            />
                        )}
                    </div>
                )}
            </div>
        </section>
    )
}

export default Events
